
import { Options, Vue } from "vue-class-component";
import { mapGetters, mapActions } from "vuex";
import { ReportingViewType } from "../../types/reporting-view";
import { UserRole } from "../../types/user-info";
import { isUserUnknown, isUserGuest } from "../../helpers/user-role-helper";
import moment from "moment-timezone";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
import { applyPlugin } from "jspdf-autotable";
import "jspdf-autotable";
import emitter from "../../store/eventBus";

@Options({
  props: {
    equipment: {
      type: Object,
      required: false,
    },
  },
  computed: {
    ...mapGetters([
      "getReportingView",
      "getUserRole",
      "getIsReportingWeeklyReportExpanded",
      "getDateRangeForWeeklyReport",
    ]),
  },
  methods: {
    ...mapActions([
      "updateReportingView",
      "reportsUpdated",
      "updateIsReportingWeeklyReportExpanded",
      "updateDateRangeForWeeklyReport",
    ]),
    triggerPDF() {
      emitter.emit("trigger-jsPDF", "");
    },
  },
  data() {
    return {
      items: [
        { title: "Item 1", body: "I am item 1 body text" },
        { title: "Item 2", body: "I am item 2 body text" },
        { title: "Item 3", body: "I am item 3 body text" },
        { title: "Item 4", body: "I am item 4 body text" },
      ],
      columns: [{ title: "Title", body: "Body" }],
      selectedWeek: this.availableWeeks[0],
    };
  },

  name: "ReportingFilters",
})
export default class ReportingFilters extends Vue {
  ReportingViewType = ReportingViewType;
  getUserRole!: UserRole;
  getIsReportingWeeklyReportExpanded!: boolean;
  getReportingView!: ReportingViewType;
  getDateRangeForWeeklyReport!: string;
  updateReportingView!: (reportingView: ReportingViewType) => void;
  updateIsReportingWeeklyReportExpanded!: (isExpanded: boolean) => void;
  updateDateRangeForWeeklyReport!: (value: string) => void;
  selectedWeek!: string | null;
  startDate!: string;
  endDate!: string;
  heading!: string;
  require: any;
  items: any;
  columns: any;
  reportsUpdated!: ({ fromDate, toDate }: any) => Promise<void>;
  async mounted(): Promise<void> {
    this.updateDateRangeForWeeklyReport("");
    this.updateReportingView(ReportingViewType.WEEKLY);
    if (this.selectedWeek) {
      await this.weekSelectedHandler(this.selectedWeek);
    }
  }

  get reportingView(): ReportingViewType {
    return this.getReportingView;
  }

  set reportingView(reportingView: ReportingViewType) {
    this.updateReportingView(reportingView);
  }

  get expandButtonLabel(): string {
    return this.getIsReportingWeeklyReportExpanded
      ? "Collapse all"
      : "Expand all";
  }

  defineAvailableWeeks = (): string[] => {
    const toDate = moment().toDate();
    let availbleWeeks: string[] = [];
    for (let i = 0; i < 52; i++) {
      let value = moment(toDate).subtract(i, "week").toDate();
      let week = moment(value).week();
      let year = moment(value).year();
      availbleWeeks.push(`${week}/${year}`);
    }
    return availbleWeeks;
  };
  availableWeeks: string[] = this.defineAvailableWeeks();
  openOrCloseAllExpansionItems(): void {
    this.updateIsReportingWeeklyReportExpanded(
      !this.getIsReportingWeeklyReportExpanded
    );
  }

  isUserUnknownFn(): boolean {
    return isUserUnknown(this.getUserRole);
  }

  generatePDF() {
    const { jsPDF } = require("jspdf");
    require("jspdf-autotable");
    applyPlugin(jsPDF);
    this.heading = "Sample PDF Generator";

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "in",
      format: "letter",
    });
    // text is placed using x, y coordinates
    doc.setFontSize(16).text(this.heading, 0.5, 0.5);
    // create a line under heading
    doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
    // Using autoTable plugin
    doc.autoTable({
      head: this.columns,
      body: this.items,
      margin: { left: 0.5, top: 0.75 },
    });

    // Creating footer and saving file
    doc.save(`${this.heading}.pdf`);
  }

  async weekSelectedHandler(val: any): Promise<void> {
    this.selectedWeek = val;
    const splitted = this.selectedWeek?.split("/");
    if (splitted && splitted?.length != 0) {
      const week = parseInt(splitted[0]);
      const year = parseInt(splitted[1]);
      this.startDate = moment()
        .year(year)
        .week(week)
        .startOf("week")
        .format("DD-MM-YYYY");
      this.endDate = moment()
        .year(year)
        .week(week)
        .endOf("week")
        .format("DD-MM-YYYY");
      let range = `From ${this.startDate} to ${this.endDate}`;
      this.updateDateRangeForWeeklyReport(range);
      if (this.getReportingView === ReportingViewType.WEEKLY) {
        this.$q.loading.show();
        const toDate = moment(this.endDate, "DD MM YYYY hh:mm:ss").toDate();
        const fromDate = moment(this.startDate, "DD MM YYYY hh:mm:ss").toDate();
        //this await function results in slowing down the reporting page.
        if (this.selectedWeek !== this.availableWeeks[0]) {
          await this.reportsUpdated({
            fromDate,
            toDate,
          });
        }
        this.$q.loading.hide();
      }
    }
  }
}
